import * as React from 'react';
import CheckoutAdditionalService from '../..';
import { useTheme } from '../../../theme';
import { useHistory, useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
const EveryTravel = ({ service }) => {
    const everyTravel = service.services[0];
    const theme = useTheme('CheckoutAdditionalService').EveryTravel;
    const { t } = useTranslation('Checkout');
    const { url } = useRouteMatch();
    const history = useHistory();
    const onEditHandler = () => {
        history.push(`${url}/explore/${everyTravel.excursionId}`);
    };
    return (React.createElement(CheckoutAdditionalService, { header: everyTravel.title, priceTotal: everyTravel.price, mode: 'aggregator', description: null, isSelected: true, coverBackgroundUrl: everyTravel.imageUrl, coverClassName: theme.cover, addClick: () => { }, buttons: [
            {
                text: t(service.canAddService ? 'Change' : 'Details'),
                action: onEditHandler
            }
        ] },
        everyTravel.date,
        " ",
        everyTravel.time));
};
export default EveryTravel;
